import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';
import { FileModel } from '../file.model';

export class CommunicationModel extends Model implements IModel<CommunicationModel> {
  title: string = '';
  message: string = '';
  link: string = '';
  platform: string = '3';
  image: FileModel = new FileModel();
  imageMobile: FileModel = new FileModel();
  imageURL: string = '';
  imageURLMobile: string = '';
  type: string = '';
  expirationDate: string = '';
  companyId: string | undefined = undefined;
  costCenterId: string | undefined = undefined;
  companyIds: string[] | undefined = undefined;
  costCenterIds: string[] | undefined = undefined;
  companyGroupId: string | undefined = undefined;
  messageRichText: string | undefined = undefined;

  static create(input: any): CommunicationModel {
    return ObjectMapper.deserialize<CommunicationModel>(CommunicationModel, input);
  }

  get typeLabel(): string {
    return this.type == '1' ? 'BANNER' : 'AVISO';
  }

}
